/// <reference path="../types.d.ts" />

import { createReducer } from '@reduxjs/toolkit';
import InitialState from './initial-state';
import { groupActions } from '../actions/groups';
import { LOAD_STATES } from './common';
import { groups } from '../stubs/groups';
import { logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';

const reducer = createReducer(InitialState.group, builder => {
  builder.addCase(logout.type, () => ({ ...InitialState.group }));
  builder.addCase(jumpContext.pending.type, () => ({ ...InitialState.group }));

  builder.addCase(groupActions.listItems.pending, state => ({
    ...state,
    items: [],
    loadState: LOAD_STATES.initial
  }));

  builder.addCase(groupActions.listItems.rejected, state => ({
    ...state,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(groupActions.listItems.fulfilled, (state, action) => {
    const { content } = action.payload;

    const { sortablePageable } = state.groupsList;
    const sp = { ...sortablePageable, pageableDefinition: action.payload };

    return {
      ...state,
      loadState: LOAD_STATES.done,
      items: content,
      sortablePageable: sp,
      selectedGroup: {
        ...groups.defaultGroup
      }
    };
  });

  builder.addCase(groupActions.saveGroup.pending, state => ({
    ...state,
    loadState: LOAD_STATES.started
  }));

  builder.addCase(groupActions.getGroupDetail.pending, state => ({
    ...state,
    loadState: LOAD_STATES.started
  }));

  builder.addCase(groupActions.getGroupDetail.rejected, state => ({
    ...state,
    loadState: LOAD_STATES.failed
  }));

  builder.addCase(groupActions.getGroupDetail.fulfilled, state => ({
    ...state,
    loadState: LOAD_STATES.done
  }));

  builder.addCase(groupActions.chooseGroup, (state, action) => ({
    ...state,
    selectedGroup: action.payload
  }));

  builder.addCase(groupActions.listEligibleGroupMembers, (state, action) => ({
    ...state,
    eligibleGroupMembers: action.payload
  }));
});

export default reducer;
